import React, { useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../head-container';
import { getImageFromS3 } from '../../../imageService';
import global from '../../index.module.scss';
import { virtualTourChallenge } from '../../../consts/virtual-tour-challenge';
import classNames from 'classnames';

const VirtualTourFirstCutChallenge = ({
  setScreenNumber,
  setScreenNumberAfterResult
}) => {
  const [challengeStep, setChallengeStep] = useState(0);
  const [selectQuestion, setSelectQuestion] = useState(virtualTourChallenge[0]);
  const [isFinish, setIsFinish] = useState(false);

  return !isFinish ? (
    <div className={styles.container}>
      <div style={{ padding: '20px 30px 0' }}>
        <HeadContainer setScreenNumber={setScreenNumber} />
      </div>
      {challengeStep !== 0 && <div className={styles.headGradient} />}
      <div className={styles.titleQuestionContainer}>
        <p
          className={styles.titleQuestion}
          dangerouslySetInnerHTML={{ __html: selectQuestion.title }}
        />
      </div>
      <img
        key={challengeStep}
        className={styles.imageQuestion}
        src={selectQuestion.image}
        alt="image-bg"
      />
      <img
        className={classNames(
          styles.roadImage,
          challengeStep === 0 && styles.roadImageFirst
        )}
        src={selectQuestion.roadImage}
        alt="image-road"
      />
      <div
        className={styles.descriptionContainer}
        style={{
          backgroundImage: `url(${getImageFromS3(
            '/images/virtual-tour-first-cut-challenge/yellow-bg.png'
          )})`
        }}
      >
        <p className={styles.descriptionTitle}>{selectQuestion.description}</p>
        <div className={styles.buttonContainer}>
          {challengeStep > 0 && (
            <button
              style={{ marginRight: 15 }}
              className={global.reviewButton}
              onClick={() => {
                setSelectQuestion(virtualTourChallenge[challengeStep - 1]);
                setChallengeStep(challengeStep - 1);
              }}
            >
              Назад
            </button>
          )}
          <button
            className={global.menuButton}
            onClick={() => {
              setIsFinish(challengeStep + 1 >= virtualTourChallenge?.length);
              setSelectQuestion(virtualTourChallenge[challengeStep + 1]);
              setChallengeStep(challengeStep + 1);
            }}
          >
            {challengeStep === 0 ? 'Починаймо!' : 'Далі'}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={styles.resultContainer}
      style={{
        backgroundImage: `url(${getImageFromS3(
          '/images/virtual-tour-first-cut-challenge/result-bg.png'
        )})`
      }}
    >
      <HeadContainer setScreenNumber={setScreenNumber} />
      <div className={styles.resultContent}>
        <img
          className={styles.resultImage}
          src={getImageFromS3(
            '/images/virtual-tour-first-cut-challenge/result-image.png'
          )}
          alt="description-bg"
        />
        <div className={styles.descriptionContainer}>
          <p className={styles.title}>
            Тепер ти не лише знаєш про кожен етап виробництва, а й сам можеш
            проводити екскурсії.
          </p>
          <p className={styles.description}>
            Сподіваємось, що тобі було цікаво!
          </p>
        </div>
        <button
          style={{ marginTop: 20 }}
          className={global.menuButton}
          onClick={setScreenNumberAfterResult}
        >
          Далі
        </button>
      </div>
    </div>
  );
};

export default VirtualTourFirstCutChallenge;
